"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuParentContext = exports.MenuParentContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
const noop = () => undefined;
const defaultContextValue = {
  closeAllSubMenus: noop,
  closeMenuRootRequested: null,
  focusMode: "mouse",
  hasContentBefore: false,
  parent: false,
  registerSubMenu: () => noop,
  layout: "compact",
  allowClickPropagation: false
};
const MenuParentContext = (0, _lodestarUtils.createContext)(defaultContextValue, "MenuParentContext");
const useMenuParentContext = () => (0, _react.useContext)(MenuParentContext);
exports.useMenuParentContext = useMenuParentContext;
const MenuParentContextProvider = _ref => {
  let {
    children,
    focusMode,
    hasContentBefore,
    onCloseRequested,
    parent,
    layout,
    allowClickPropagation
  } = _ref;
  // Array tracking all submenus in this Menu.
  const subMenuRegistrations = (0, _react.useRef)([]);
  const closeAllSubMenus = (0, _react.useCallback)(() => {
    subMenuRegistrations.current.forEach(cb => cb());
  }, []);
  const registerSubMenu = (0, _react.useCallback)(cb => {
    subMenuRegistrations.current.push(cb);
    return () => {
      subMenuRegistrations.current = subMenuRegistrations.current.filter(callback => callback !== cb);
    };
  }, []);
  const parentContextValue = (0, _react.useMemo)(() => ({
    closeAllSubMenus,
    closeMenuRootRequested: onCloseRequested,
    focusMode,
    hasContentBefore,
    parent,
    registerSubMenu,
    layout,
    allowClickPropagation
  }), [closeAllSubMenus, onCloseRequested, focusMode, hasContentBefore, layout, parent, registerSubMenu, allowClickPropagation]);
  return /*#__PURE__*/_react.default.createElement(MenuParentContext.Provider, {
    value: parentContextValue
  }, children);
};
exports.MenuParentContextProvider = MenuParentContextProvider;
//# sourceMappingURL=MenuParentContext.js.map